import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-2xl hover:text-accent-400 transition-colors">
              51黑料
            </Link>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              吃瓜第一线，黑料天天见。国内领先的娱乐资讯聚合平台，为您提供最新最热的吃瓜爆料内容。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-background-200 mb-4">
              <a href="#footer-categories" className="hover:text-accent-400 transition-colors">热门分类</a>
            </h4>
            <div className="flex flex-col gap-2">
              {categories.filter((c) => c.id !== "all").slice(0, 5).map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-medium text-background-200 mb-4">
              <a href="#footer-links" className="hover:text-accent-400 transition-colors">快速链接</a>
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                今日黑料
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-accent-400 transition-colors whitespace-nowrap">
                联系我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="font-medium text-background-200 mb-4">
              <a href="#footer-contact" className="hover:text-accent-400 transition-colors">联系方式</a>
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>邮箱：contact@51heiliao.com</span>
              <span>微信：51heiliao_official</span>
              <span>微博：@51黑料吃瓜网</span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 51黑料吃瓜网. All rights reserved.
          </p>
          <p className="text-xs text-background-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}